import { API, Auth } from '../../apis/limeAuthUtils/apiWrapper';
import { getCurrentAuthUserAlias, getCurrentAuthUserEmail } from '../../lib/utils';

export async function listAllLabs() {
    /**
     * function to list all labs
     */
    const apiName = 'v1/lab-management';
    const requester = await getCurrentAuthUserEmail();
    const myInit = {
        queryStringParameters: {
            requester: requester,
        },
    };
    return await API.get(apiName, '/v1/labs', myInit);
}

export async function onboardLab(
    labId,
    owner,
    accessGroup,
    ticketCategory,
    ticketType,
    ticketItem,
    ticketGroup,
    dotsPoolName,
    monitorEnabled,
    ddfPoolID = '',
    ddfPoolRegion = ''
) {
    /**
     * function to onboard a lab
     */
    const apiName = 'v1/lab-management';
    const myInit = {
        body: {
            labId: labId,
            accessGroup: accessGroup,
            category: ticketCategory,
            type: ticketType,
            item: ticketItem,
            resolverGroup: ticketGroup,
            dotsPoolName: dotsPoolName,
            monitorEnabled: monitorEnabled,
            ddfPoolID: ddfPoolID,
            ddfPoolRegion: ddfPoolRegion,
            requester: owner,
        },
    };
    return await API.put(apiName, '/v1/labs', myInit);
}

export async function configureLab(
    labId,
    owner,
    accessGroup,
    ticketCategory,
    ticketType,
    ticketItem,
    ticketGroup,
    dotsPoolName,
    monitorEnabled,
    alarmRules,
    ddfPoolID = '',
    ddfPoolRegion = ''
) {
    /**
     * function to configure lab
     */
    const apiName = 'v1/lab-management';
    const requester = await getCurrentAuthUserEmail();
    const body = {
        labId: labId,
        owner: owner,
        accessGroup: accessGroup,
        category: ticketCategory,
        type: ticketType,
        item: ticketItem,
        resolverGroup: ticketGroup,
        dotsPoolName: dotsPoolName,
        monitorEnabled: monitorEnabled,
        ddfPoolID: ddfPoolID,
        ddfPoolRegion: ddfPoolRegion,
        requester: requester,
    };
    if (alarmRules !== undefined) {
        body.alarmRules = alarmRules;
    }
    const myInit = { body };
    return await API.put(apiName, `/v1/labs/${labId}`, myInit);
}

export async function offboardLab(labId) {
    /**
     * function to offboard lab
     */
    const apiName = 'v1/lab-management';
    const requester = await getCurrentAuthUserEmail();
    const myInit = {
        body: {
            labId: labId,
            requester: requester,
        },
    };
    return await API.del(apiName, `/v1/labs/${labId}`, myInit);
}
